import axios from 'axios'
import { set } from 'vue'
import store from '../'

// initial state
const state = () => ({
  assessment: null
})

// getters
const getters = {
  assessment: state => {  
    let assessment = JSON.parse(localStorage.getItem('assessment'))
    if (assessment) {
      actions.setAssessment(store, assessment)
    }
    return assessment
  }
}

// actions
const actions = {
  createAssessment({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      axios.post(`${'/assessment/'}`, data).then(response => {
        commit('SET_ASSESSMENT', response.data)
        return resolve(response)
      }).catch(error => reject(error))
    })
  },
  setAssessment({ commit, state }, data) {
    commit('SET_ASSESSMENT', data)
  },
  updateAssessment({commit, state}, data) {
    return new Promise((resolve, reject) => {
      axios.patch(`${'/assessment/'}`, data).then(response => {
        commit('UPDATE_ASSESSMENT', data)
        return resolve(response)
      }).catch(error => reject(error))
    })
  }
}

// mutations
const mutations = {
  SET_ASSESSMENT: (state, data) => {
    state.assessment = data
    localStorage.setItem('assessment', JSON.stringify(data))
  },
  UPDATE_ASSESSMENT: (state, data) => {
    if (Object.keys(data).length) {
      set(state, 'assessment', { ...data })
      localStorage.setItem('assessment', JSON.stringify(state.assessment))
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}